// extracted by mini-css-extract-plugin
export default {"container":"Heading_container__rdL3Q","editIcon":"Heading_editIcon__ISahu","editText":"Heading_editText__HTN5O","navLink":"Heading_navLink__Bdn7C"};